import ICONS from '../../lib/icons.js'
import { DEV } from '../../lib/env.js'

const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- ui-icon ---
let __fez_component_0;
{

__fez_component_0 = class {
  NAME = 'span'

  PROPS = {
    name: String,
    size: { type: Number, default: 20 },
    weight: { type: String, default: 'regular', enum: ['regular', 'fill'] },
  }

  beforeRender() {
    const name = this.props.name || ''
    const key = this.props.weight === 'fill' ? `${name}-fill` : name
    this.state.svg = ICONS[key] || ICONS[name] || ''
    if (!this.state.svg && DEV) console.warn(`ui-icon: unknown icon "${key}", run bun run icons`)
  }

  CSS = `:fez {
display:inline-flex;flex-shrink:0;line-height:0;vertical-align:middle;.glyph{display:block;color:inherit !important;svg{width:100%;height:100%;display:block}}.missing{border:1px dashed var(--color-danger);border-radius:var(--radius-sm)}
}`

  HTML = `<span class="glyph" class:missing={!state.svg} style="width: {props.size}px; height: {props.size}px" aria-hidden="true">{@html state.svg}</span>`
};
}

Fez('ui-icon', __fez_component_0);

export default __fez_component_0;
